import { render } from "./PageImages.vue?vue&type=template&id=021b913b&scoped=true"
import script from "./PageImages.vue?vue&type=script&lang=js"
export * from "./PageImages.vue?vue&type=script&lang=js"

import "./PageImages.vue?vue&type=style&index=0&id=021b913b&lang=scss&scoped=true"
import "./PageImages.vue?vue&type=style&index=1&id=021b913b&lang=scss"
script.render = render
script.__scopeId = "data-v-021b913b"

export default script